module.exports = __webpack_public_path__ + "fonts/Benzin-Regular.5a24f0d.ttf";